import { setCookie } from "./cookies";

const PADDLE_COUPON_PARAM = "coupon";
const PADDLE_COUPON_COOKIE = "sd-paddle-coupon";
const COUPON_EXPIRY_DAYS = 30;

export const capturePaddleCoupon = () => {
  const params = new URLSearchParams(window.location.search);
  const coupon = params.get(PADDLE_COUPON_PARAM);

  if (coupon) {
    setCookie({
      name: PADDLE_COUPON_COOKIE,
      value: coupon,
      days: COUPON_EXPIRY_DAYS,
    });

    params.delete(PADDLE_COUPON_PARAM);
    const newSearch = params.toString();
    const newUrl = `${window.location.pathname}${newSearch ? `?${newSearch}` : ""}${window.location.hash}`;
    window.history.replaceState(null, "", newUrl);
  }
};
